import { render } from "./HeroiconsOutlineSwitchVertical.vue?vue&type=template&id=1ffc3335"
const script = {}

import exportComponent from "/home/omid_es327/Projects/mohovers/dev/dev-laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineSwitchVertical.vue"]])

export default __exports__